import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { AuthService } from "./authServices";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (this.authService.isSessionExpiredDueToInactivity()) {
      if (!this.authService.getIsAuth()) {
        this.authService.reconcileExpiredSessionAfterRefresh();
        this.router.navigate(["/login"]);
        return false;
      }
      this.authService.showSessionExpiredDialog();
      return false;
    }

    const isAuth = this.authService.getIsAuth();
    if (!isAuth) {
      this.router.navigate(["/login"]);
      return false;
    }
    if (this.authService.getIsPasswordChangeRequired()) {
      this.router.navigate(["/login/change-password"]);
      return false;
    }
    return true;
  }
}
